'use strict';

wbApp.factory('languageService', ['$translate', '$timeout', 'preferredLanguage', 'tenantInfo',
    function (translate, $timeout, preferredLanguage, tenantInfo) {
        translate.use(preferredLanguage);

        var languages = [
                { key: 'en', nameResID: 'TXT_LANG_EN', img: '/Bundles/css/images/flags/us.svg' },
                { key: 'cs', nameResID: 'TXT_LANG_CS', img: '/Bundles/css/images/flags/cz.svg' },
                { key: 'sk', nameResID: 'TXT_LANG_SK', img: '/Bundles/css/images/flags/sk.svg' },
                { key: 'de', nameResID: 'TXT_LANG_DE', img: '/Bundles/css/images/flags/de.svg' }];

        function setActiveLanguage(langKey) {
            for (var i = 0; i < languages.length; i++) {
                if (languages[i].key === langKey) {
                    languages[i].active = true;
                    moment.locale(langKey);
                } else {
                    languages[i].active = false;
                }
            }

            var expires = new Date();
            expires.setDate(expires.getDate() + 10000);
            expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));

            var cookieValue = 'c=' + langKey + '|uic=' + langKey;

            var newCookie = 'culture=' + cookieValue + '; expires=' + expires.toUTCString() + '; domain=' + tenantInfo.domain + '; path=/';
            document.cookie = newCookie;
        }

        function currentLangKey(langKey) {
            if (langKey) {
                if (langKey !== translate.use()) {
                    setActiveLanguage(langKey);
                    // Do no set language immediately, done in app.js on reload
                    return translate.use();
                }
            }
            return translate.use();
        }

        setActiveLanguage(translate.use());

        return {
            currentLangKey: currentLangKey,

            currentLanguage: function () {
                for (var i = 0; i < languages.length; i++) {
                    if (languages[i].key === currentLangKey()) {
                        return languages[i];
                    }
                }
                return {};
            },

            supportedLanguages: languages
        }
}]);